import { render } from "./CardTemperatura.vue?vue&type=template&id=35fb47e8&scoped=true"
import script from "./CardTemperatura.vue?vue&type=script&lang=js"
export * from "./CardTemperatura.vue?vue&type=script&lang=js"

import "./CardTemperatura.vue?vue&type=style&index=0&id=35fb47e8&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fb47e8"]])

export default __exports__